module.exports = __webpack_public_path__ + "img/white-stickers.47d75cca.png";